import React from "react";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
} from "react-router-dom";
import Layout from "../Components/Layouts/Layout";
import HomePage from "../Pages/HomePage/HomePage";
import ExpertDetailsPage from "../Pages/ExpertDetailsPage/ExpertDetailsPage";
import CourseDetailsPage from "../Pages/CourseDetailsPage/CourseDetailsPage";
import ExpertListingPage from "../Pages/ExpertListingPage/ExpertListingPage";
import PrivacyPolicyPage from "../Pages/PrivacyPolicyPage/PrivacyPolicyPage";
import TermsAndCondition from "../Pages/TermsAndCondition/TermsAndCondition";
import Blogs from "../Pages/Blogs/Blogs";
import PragnancyCare from "../Pages/Service/PragnancyCare";
import Workshops from "../Pages/Workshop/Workshops";
import MentalHelth from "../Pages/MentalHelth/MentalHelth";
import InnerBlog from "../Pages/InnerBlog/InnerBlog";
import CancellationandRefundPolicy from "../Pages/CancellationandRefundPolicy/CancellationandRefundPolicy";
import ContactUs from "../Pages/ContactUs/ContactUs";
import EbookDownloadPage from "../Pages/LandingPage/EbookDownloadPage";
import ProfilePage from "../Pages/Profile/ProfilePage";
import Account from "../Components/Profile/Account";
import Orders from "../Components/Profile/Order";
import UpcomingSession from "../Components/Profile/Session/UpcomingSession";
import ExpertRedirect from "../Components/Redirect/ExpertRedirect";
import AccountDeletedPage from "../Pages/Profile/AccountDeletedPage";
import WorkshopFeedbackPage from "../Pages/FeedbackPage/WorkshopFeedbackPage";
import PageNotFound from "../Pages/PageNotFound/PageNotFound";
import SessionDataPage from "../Pages/FeedbackPage/SessionDataPage";
import RevenueDashboard from "../Components/Profile/RevenueDashboard";
import MyLearningPage from "../Pages/MyLearningPage/MyLearningPage";
import PrivateRoute from "./PrivateRoute";
import WorkshopPage from "../Pages/WorkshopPage/WorkshopPage";
import LoginPage from "../Pages/Profile/LoginPage";
import BookingSessionPage from "../Pages/BookingSessionPage/BookingSessionPage";
import OrderDetails from "../Components/Profile/Orders/OrderDetails";
import BookingSessionDetailsPage from "../Pages/BookingSessionPage/BookingSessionDetailsPage";
import SessionFeedbackPage from "../Pages/FeedbackPage/SessionFeedbackPage";
import EventPage from "../Pages/Events/EventPage";
import Recipes from "../Pages/Recipes/Recipes";
import RecipeList from "../Pages/Recipes/RecipeList";
import ChallengePage from "../Pages/Challenges/ChallengePage";
import ChallengeDetails from "../Pages/Challenges/ChallengeDetails";
import ChallengeList from "../Pages/Challenges/ChallengeList";
import TokenLoginPage from "../Pages/Profile/TokenLoginPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<HomePage />} />
      <Route path="/bookings/packageNotfound/404" element={<PageNotFound />} />
      <Route
        path="/experts/:expertslug/workshop/:workshopSlug"
        element={<ExpertRedirect />}
      />
      <Route path="/workshop/:workshopSlug" element={<CourseDetailsPage />} />
      <Route
        path="/workshop/:workshopSlug/feedback"
        element={
          <PrivateRoute>
            <WorkshopFeedbackPage />
          </PrivateRoute>
        }
      />
      <Route path="/events/details/:eventSlug" element={<EventPage />} />
      <Route
        path="/events/:eventSlug/feedback"
        element={
          <PrivateRoute>
            <WorkshopFeedbackPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/expert/:expertSlug/booking/feedback"
        element={
          <PrivateRoute>
            <SessionFeedbackPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/expert/:expertSlug/bookings/:bookingId/session-data/:packageID"
        element={
          <PrivateRoute>
            <SessionDataPage />
          </PrivateRoute>
        }
      />
      <Route path="/challenges" element={<ChallengeList />} />
      <Route path="/challenges/:challengeSlug" element={<ChallengeDetails />} />
      <Route
        path="/my-learning/challenge/:challengePurchaseId/:challengeSlug"
        element={<ChallengePage />}
      />
      <Route
        path="/my-learning/challenge/:challengePurchaseId/:challengeSlug/checkpoint/:checkpointSlug"
        element={<ChallengePage />}
      />
      <Route path="/recipe/:slug" element={<Recipes />} />
      <Route path="/recipe" element={<RecipeList />} />
      <Route path="/experts" element={<ExpertListingPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-and-condition" element={<TermsAndCondition />} />
      <Route path="/experts/:slug" element={<ExpertDetailsPage />} />
      <Route path="/:expertslug" element={<ExpertRedirect />} />
      <Route
        path="/:expertslug/:pageType/:itemSlug"
        element={<ExpertRedirect />}
      />
      <Route path="/:expertslug/:pageType" element={<ExpertRedirect />} />
      <Route
        path="/cancellation-and-refund-policy"
        element={<CancellationandRefundPolicy />}
      />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogs/:slug" element={<InnerBlog />} />
      <Route path="/pregnancy-care" element={<PragnancyCare />} />
      <Route path="/workshops" element={<Workshops />} />
      <Route path="/mental-health" element={<MentalHelth />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/bookings/:expertslug/" element={<BookingSessionPage />} />
      <Route
        path="/bookings/:expertslug/details"
        element={<BookingSessionDetailsPage />}
      />
      <Route
        path="/:expertslug/ebook/download/:itemSlug"
        element={<EbookDownloadPage />}
      />
      <Route
        path="/delete_account"
        element={
          <PrivateRoute>
            <AccountDeletedPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/my-learning"
        element={
          <PrivateRoute>
            <MyLearningPage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/my-learning/ondemand/:workshopPurchaseId/:workshopSlug"
        element={
          <PrivateRoute>
            <WorkshopPage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/my-learning/ondemand/:workshopPurchaseId/:workshopSlug/chapter/:chapterId"
        element={
          <PrivateRoute>
            <WorkshopPage />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        }
      >
        <Route path="account" element={<Account />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:id" element={<OrderDetails />} />
        <Route path="revenue/*" element={<RevenueDashboard />}>
          <Route
            path="overview"
            element={<RevenueDashboard page="overview" />}
          />
          <Route
            path="transactions"
            element={<RevenueDashboard page="transactions" />}
          />
          <Route index element={<Navigate to="overview" />} />
        </Route>
        <Route path="sessions/upcoming" element={<UpcomingSession />} />
        <Route index element={<Navigate to="account" />} />
      </Route>
      {<Route path="*" element={<PageNotFound />} />}
      <Route path="/auth/token-login/:token" element={<TokenLoginPage />} />
    </Route>
  )
);

function Mainroutes() {
  return <RouterProvider router={router} />;
}

export default Mainroutes;
